
let HomeProductCards = () => {
  // Elements
  const noStarHtml = document.createElement("span");
  noStarHtml.classList.add("review-star");
  noStarHtml.classList.add("review-star--empty");

  const halfStarHtml = document.createElement("span");
  halfStarHtml.classList.add("review-star");
  halfStarHtml.classList.add("review-star--half");

  const fullStarHtml = document.createElement("span");
  fullStarHtml.classList.add("review-star");
  fullStarHtml.classList.add("review-star--full");

  let reviews = {};

  async function Init() {
    let onHomePage = document.body.classList.contains("index") || document.body.getAttribute("data-curr-url") === "https://sukoshimart.com/"

    if (onHomePage) await LoadReviews();
  }

  /*
    Loads reviews for all product cards on the home page
  */
  async function LoadReviews() {
    // Get all product cards
    let reviewCards = Array.from(document.querySelectorAll(".featured-card .featured-card__reviews"));
    let reqFailed = false;

    for (let i = 0; i < reviewCards.length; i++) {
      let reviewElem = reviewCards[i];

      if (reviewElem.classList.contains("sk-hidden")) {
        let key = reviewElem.getAttribute("data-appkey");
        let id = reviewElem.getAttribute("data-product-id");
        let reqUrl = `https://api.yotpo.com/products/${key}/${id}/bottomline`;
        let result = undefined;

        if (reviews[`${id}`]) {
          result = reviews[`${id}`];
        } else {
          result = await fetch(reqUrl, {
            method: 'GET',
            headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
          })
          .then(res => res.json())
          .then(res => {
            if (res.status.code === 404) {
              reviewElem.removeAttribute("data-appkey");
              reviewElem.removeAttribute("data-product-id");
              reviewElem.remove();

              return undefined;
            }

            return res;
          })
          .catch(err => {
            reqFailed = true;
            return undefined;
          });
        }

        if (result) {
          // Cache result to reduce requests by half
          if (!reviews[`${id}`]) reviews[`${id}`] = result;

          // Get review count
          let totalReviews = result.response.bottomline.total_reviews;
          let averageScore = result.response.bottomline.average_score;

          if (totalReviews === 0) {
            reviewElem.removeAttribute("data-appkey");
            reviewElem.removeAttribute("data-product-id");
            reviewElem.remove();

            continue;
          }

          if (totalReviews > 0) {
            reviewElem.innerText = `(${totalReviews}) / ${averageScore}`;
          }

          if (averageScore > 0) {
            reviewElem.innerText = `(${totalReviews}) / ${averageScore}`;
          }

          // Create stars based on reviews
          let reviewStars = [];
          let reviewStarsElem = document.createElement("div");
          reviewStarsElem.classList.add("review-stars");

          if (averageScore > 4.7) {
            // 5 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
          } else if (averageScore > 4.2) {
            // 4.5 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(halfStarHtml.cloneNode());
          } else if (averageScore > 3.7) {
            // 4 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 3.2) {
            // 3.5 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(halfStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 2.7) {
            // 3 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 2.2) {
            // 2.5 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(halfStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 1.7) {
            // 2 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 1.2) {
            // 1.5 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(halfStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 0.7) {
            // 1 stars
            reviewStars.push(fullStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else if (averageScore > 0.2) {
            // 0.5 stars
            reviewStars.push(halfStarHtml);
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          } else {
            // 0 stars
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
            reviewStars.push(noStarHtml.cloneNode());
          }

          reviewStars.forEach(star => reviewStarsElem.appendChild(star));

          // Add review count
          let reviewCountElem = document.createElement("span");
          reviewCountElem.classList.add("review-count");

          if (totalReviews > 99) {
            totalReviews = "99+";
          }

          reviewCountElem.innerText = `(${totalReviews})`;

          // Populate
          reviewElem.innerText = "";
          reviewElem.appendChild(reviewStarsElem);
          reviewElem.appendChild(reviewCountElem);

          // Show and remove data
          reviewElem.removeAttribute("data-appkey");
          reviewElem.removeAttribute("data-product-id");
          reviewElem.classList.remove("sk-hidden");
        }
      }

      if (reqFailed) {
        // Wait for 10 seconds and try again
        setTimeout(() => {
          LoadReviews();
        }, 10000);

        break;
      }
    }
  }

  Init();

  return Object.freeze({});
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    HomeProductCards = HomeProductCards();
  });
} else {
  HomeProductCards = HomeProductCards();
}
